/**
 * FormSection organism - groups related form fields with consistent styling
 */

import React from 'react';
import { VStack, Text, Divider } from '@chakra-ui/react';
import { BaseComponentProps } from '../../types';

export interface FormSectionProps extends BaseComponentProps {
  /** Section title */
  title: string;
  /** Optional section description */
  description?: string;
  /** Form fields to render */
  children: React.ReactNode;
  /** Whether to show divider after section */
  showDivider?: boolean;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  children,
  showDivider = false,
  className,
  testId,
}) => {
  return (
    <VStack
      spacing={6}
      align="stretch"
      className={className}
      data-testid={testId}
    >
      {/* Section Header */}
      <div>
        <Text fontSize="lg" fontWeight="600" mb={description ? 2 : 0}>
          {title}
        </Text>
        {description && (
          <Text fontSize="sm" color="gray.600">
            {description}
          </Text>
        )}
      </div>

      {/* Form Fields */}
      <VStack spacing={4} align="stretch">
        {children}
      </VStack>

      {/* Optional Divider */}
      {showDivider && <Divider />}
    </VStack>
  );
};
